import Skeleton from "react-loading-skeleton";
import "@/Styles/SkeletonStyle.css";
import type { BrandsSelected } from "@/Models/MBrand/BrandsSelected";

type Props = {
  filterData: (value: string, checked: boolean) => void;
  datosMarcas: BrandsSelected[];
  selectBrand: string[];
  onChanges: (value: number) => void;
  isLoading: boolean;
};

export const FilterWeb = ({
  filterData,
  datosMarcas,
  selectBrand,
  onChanges, //orderTo,
  isLoading,
}: Props): JSX.Element => {
  const groupNames = datosMarcas.reduce<Record<string, BrandsSelected[]>>(
    (acc, marc) => {
      const brand = marc.brand;
      if (!acc[brand]) {
        acc[brand] = [];
      }
      acc[brand].push(marc);
      return acc;
    },
    {}
  );

  const capitalizeToLetters = (letters: string) => {
    if (!letters) return "";
    var letra = letters.toLowerCase(); //minusculas
    return letra;
  };

  const handleOnchange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChanges(Number(e.target.value));
  };

  const handleOnChangeSelectedCheck = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const { name, checked } = e.target;
    filterData(name, checked);
  };

  return (
    <>
      <aside className="widget widget_shop" style={{ backgroundColor: "#fff" }}>
        <h4 className="widget-title develop___Color_SalePrice__dark develop__fontFamilys">
          Filtrar
        </h4>
        <div className="filter_div__develop">
          <figure className="ps-custom-scrollbar" data-height="250">
            {isLoading ? (
              <Skeleton height={350} />
            ) : datosMarcas ? (
              Object.keys(groupNames).map((brand, index) => (
                <div className="ps-checkbox" key={index}>
                  <input
                    className="form-control"
                    type="checkbox"
                    id={brand + 1}
                    name={brand}
                    onChange={handleOnChangeSelectedCheck}
                    checked={selectBrand.includes(brand)}
                  />
                  <label
                    htmlFor={brand + 1}
                    className="develop___product-title develop___Color_SalePrice__dark develop__fontFamilys__titles">
                    {capitalizeToLetters(brand)}
                  </label>
                </div>
              ))
            ) : (
              <Skeleton height={350} />
            )}
          </figure>
        </div>
        <div className="border-top">
          <figure className="p-2">
            <h4 className="widget-title develop___Color_SalePrice__dark develop__fontFamilys">
              Ordenar
            </h4>

            {isLoading ? (
              <Skeleton height={50} />
            ) : datosMarcas ? (
              <select
                className="ps-select p-4 w-100 border develop___borderColor"
                onChange={handleOnchange}>
                <option value="0">Ordenar Por</option>
                <option value="1">Precio: mayor a menor</option>
                <option value="2">Precio: menor a mayor</option>
                <option value="3">Mayor calificación</option>
              </select>
            ) : (
              <Skeleton height={50} />
            )}
          </figure>
        </div>
      </aside>
    </>
  );
};
